import React, { FC } from 'react';
import { Divider, Grid, List, makeStyles, Theme, Typography } from '@material-ui/core';
import { RetailPhoneFormat, RetailTextInput } from 'components/retail/structures';
import retailStores from 'stores/retail';
import { observer } from 'mobx-react-lite';
import { isMajorEnergy } from 'config/suppliers';
import useI18n from "evcharging/hooks/useI18n";

const useStyles = makeStyles((theme: Theme) => {
  return {
    title: {
      fontSize: 16,
      fontWeight: 'normal',
      color: '#000',
      paddingBottom: 12,
      paddingTop: 20,
    },
    description: {
      color: '#959595',
      fontSize: 14,
    },
    list: {
      marginTop: theme.spacing(8),
      padding: 0,
      margin: theme.spacing(0, -3),
    },
    line: {
      color: '#eaeaea',
      width: '100%',
      height: 1,
    },
  };
});

const ResidentialCustomerInformationForm: FC = observer(() => {
  const classes = useStyles();
  const {
    residentialCustomerInformationStore: { form, errors, onChange, getSelectedPlan },
  } = retailStores;
  const isMajor = isMajorEnergy(getSelectedPlan().supplier);

  const { t } = useI18n();

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={4}>
          <RetailTextInput
            label={t('form.label.firstName')}
            id={'First Name'}
            placeholder={t('form.placeholder.firstName')}
            value={form.firstName}
            onChange={onChange('firstName')}
            required
            errorMessage={errors.firstName || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <RetailTextInput
            label={t('form.label.middleName')}
            id={'Middle Name'}
            placeholder={t('form.placeholder.middleName')}
            value={form.middleName}
            onChange={onChange('middleName')}
            errorMessage={errors.middleName || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <RetailTextInput
            label={t('form.label.lastName')}
            id={'Last Name'}
            placeholder={t('form.placeholder.lastName')}
            value={form.lastName}
            onChange={onChange('lastName')}
            required
            errorMessage={errors.lastName || ''}
          />
        </Grid>
        {isMajor && (
          <Grid item xs={12} sm={6} lg={4}>
            <RetailTextInput
              label={t('retail.relationship-to-account')}
              id={'Relationship'}
              placeholder={t('customer.spouse')}
              value={form.relationship}
              onChange={onChange('relationship')}
              errorMessage={errors.relationship || ''}
              required
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6} lg={4}>
          <RetailTextInput
            label={t('form.label.phone')}
            id={'Phone Number'}
            placeholder={'000-0000-000'}
            value={form.phone}
            InputProps={{ inputComponent: RetailPhoneFormat }}
            onChange={onChange('phone')}
            required
            errorMessage={errors.phone || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <RetailTextInput
            label={t('form.label.email')}
            id={'Email Address'}
            placeholder={'name@domain.com'}
            value={form.email}
            onChange={onChange('email')}
            required
            errorMessage={errors.email || ''}
          />
        </Grid>
      </Grid>

      <List className={classes.list}>
        <Divider className={classes.line} />
      </List>

      <Typography variant={'h5'} className={classes.title}>
        {t('customer.please-fill')}
      </Typography>
      <Grid lg={11} sm={12} item>
        <Typography className={classes.description}>
          {t('customer.info')}
        </Typography>
      </Grid>
    </>
  );
});

export default ResidentialCustomerInformationForm;
